import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { db } from '../firebaseConfig';
import { collection, getDocs, query, orderBy, where } from 'firebase/firestore';
import './CheckoutPage.css'; // Reusing the same CSS for now
import DeliveryOptions from './DeliveryOptions';
import AddressForm from './AddressForm';
import BankTransferInfoModal from './BankTransferInfoModal';

const CheckoutDeliveryPage = ({ onWompiPayment, onBankTransfer }) => {
  const navigate = useNavigate();
  const { cartItems, getCartTotal, clearCart } = useCart();
  const [deliveryOption, setDeliveryOption] = useState('domicilio'); // 'domicilio' or 'recoger'
  const [customerName, setCustomerName] = useState('');
  const [customerEmail, setCustomerEmail] = useState('');
  const [customerPhone, setCustomerPhone] = useState('');
  const [address, setAddress] = useState('');
  const [sedes, setSedes] = useState([]);
  const [selectedSede, setSelectedSede] = useState(null);

  const [isBankTransferInfoModalOpen, setIsBankTransferInfoModalOpen] = useState(false);
  const [currentBookingDetails, setCurrentBookingDetails] = useState(null);

  const totalPrice = getCartTotal();

  useEffect(() => {
    const fetchSedes = async () => {
      const sedesCollection = collection(db, 'menuSedes');
      const q = query(sedesCollection, where('visible', '==', true), orderBy('name'));
      const sedesSnapshot = await getDocs(q);
      const sedesList = sedesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setSedes(sedesList);
      if (sedesList.length > 0) {
        setSelectedSede(sedesList[0]); // Select the first sede by default
      }
    };
    fetchSedes();
  }, []);

  const handlePayment = (paymentMethod) => {
    const customerData = {
      fullName: customerName,
      email: customerEmail,
      phoneNumber: customerPhone,
    };

    if (!customerName || !customerEmail || !customerPhone) {
      alert('Por favor, completa todos los datos del cliente.');
      return;
    }

    if (deliveryOption === 'domicilio' && !address) {
      alert('Por favor, ingresa tu dirección de domicilio.');
      return;
    }

    if (deliveryOption === 'recoger' && !selectedSede) {
      alert('Por favor, selecciona una sede para recoger tu pedido.');
      return;
    }

    const orderDetails = {
      customerData,
      cartItems,
      precioTotal: totalPrice, // Renamed to precioTotal
      deliveryOption,
      address: deliveryOption === 'domicilio' ? address : null,
      sede: deliveryOption === 'recoger' ? selectedSede : null,
      paymentMethod,
      status: 'pendiente',
      createdAt: new Date().toISOString(),
    };

    if (paymentMethod === 'wompi') {
      onWompiPayment(orderDetails);
      // console.log("Wompi payment selected", orderDetails);
    } else if (paymentMethod === 'transferencia') {
      console.log("Debug: orderDetails before onBankTransfer:", orderDetails);
      onBankTransfer(orderDetails);
      // console.log("Bank transfer selected", orderDetails);
      setCurrentBookingDetails(orderDetails);
      setIsBankTransferInfoModalOpen(true);
    }
  };

  if (cartItems.length === 0) {
    return (
      <div className="checkout-page-container">
        <h2>Tu carrito está vacío</h2>
        <button onClick={() => navigate('/menu')} className="back-button">Volver al Menú</button>
      </div>
    );
  }

  return (
    <div className="checkout-page-container">
      <button onClick={() => navigate('/menu')} className="back-button">← Volver al Menú</button>
      <h2>Checkout</h2>

      <div className="checkout-content-grid">
        <div className="checkout-left-column">
          <div className="customer-data-form-section">
            <h3>Datos del Cliente</h3>
            <input
              type="text"
              placeholder="Nombre Completo"
              value={customerName}
              onChange={(e) => setCustomerName(e.target.value)}
            />
            <input
              type="email"
              placeholder="Correo Electrónico"
              value={customerEmail}
              onChange={(e) => setCustomerEmail(e.target.value)}
            />
            <input
              type="tel"
              placeholder="Número de Teléfono"
              value={customerPhone}
              onChange={(e) => setCustomerPhone(e.target.value)}
            />
          </div>

          <DeliveryOptions 
            selectedOption={deliveryOption} 
            onSelectOption={setDeliveryOption} 
            sedes={sedes}
            selectedSede={selectedSede}
            onSelectSede={setSelectedSede}
          />

          {deliveryOption === 'domicilio' && (
            <AddressForm 
              address={address} 
              onAddressChange={setAddress} 
            />
          )}

        </div>

        <div className="checkout-right-column">
          <div className="checkout-details-section">
            <h3>Resumen del Pedido</h3>
            {cartItems.map(item => (
              <div key={item.id} className="summary-item">
                <span>{item.name} x {item.quantity}</span>
                <span>${(item.price * item.quantity).toLocaleString('es-CO')}</span>
              </div>
            ))}
            <hr />
            <div className="summary-item">
              <strong>Total a pagar:</strong>
              <strong>${totalPrice.toLocaleString('es-CO')} COP</strong>
            </div>
          </div>

          <div className="payment-options-section">
            <h3>Selecciona tu método de pago</h3>
            <button 
              className="payment-button wompi"
              onClick={() => handlePayment('wompi')}
            >
              Paga con Tarjeta o PSE
            </button>
            <button 
              className="payment-button bank-transfer"
              onClick={() => handlePayment('transferencia')}
            >
              Transferencia Bancaria
            </button>
          </div>
        </div>
      </div>

      {isBankTransferInfoModalOpen && currentBookingDetails && (
        <BankTransferInfoModal
          bookingDetails={currentBookingDetails}
          onClose={() => {
            setIsBankTransferInfoModalOpen(false);
            clearCart();
            navigate('/'); // Redirect after closing modal
          }}
        />
      )}
    </div>
  );
};

export default CheckoutDeliveryPage;
